import type { ProjectsReducerState } from './types';

/**
 * projectsSelector
 * Selector for the projects state.
 */
export const projectsSelector = (state: ProjectsReducerState) => state.baus.projects;

/**
 * selectOrganizations
 * Selects the organizations data from state.
 */
export const selectOrganizations = (state: ProjectsReducerState) =>
  projectsSelector(state).organizations;

/**
 * selectIsLoading
 * Selects the isLoading data from state.
 */
export const selectIsLoading = (state: ProjectsReducerState) => projectsSelector(state).isLoading;

/**
 * selectProjects
 * Selects the projects data from state.
 */
export const selectProjects = (state: ProjectsReducerState) => projectsSelector(state).projects;
